module.exports = __webpack_public_path__ + "static/media/phone.30cab4ad.svg";